
const MvmStatus = {
    // RASCUNHO - 1
    FLAG_STATUS_DRAFT: "RAS",
            
    // CANCELADO - 12
    FLAG_STATUS_CANCELLED: "CAN",

    // PENDENTE DE ENTRADA DE MVM - 2
    FLAG_STATUS_PENDING_ENTRANCE: "PEM",

    // PENDENTE DE INICIAR DESCARGA - 3
    FLAG_STATUS_PENDING_UNLOAD: "PID",    

    // PENDENTE DE FINALIZAR DESCARGA - 4
    FLAG_STATUS_PENDING_FINISH_UNLOAD: "PFD",

    // PENDENTE DE INICIAR CARGA - 5
    FLAG_STATUS_PENDING_LOAD: "PIC",

    // PENDENTE DE FINALIZAR CARGA - 6
    FLAG_STATUS_PENDING_FINISH_LOAD: "PFC",

    // PENDENTE DE ORDEM DE TRANSPORTE - 7
    FLAG_STATUS_PENDING_TRANSPORT_ORDER: "POT",

    // PENDENTE DE FATURAMENTO - 9
    FLAG_STATUS_PENDING_INVOICING: "PFA",     

    // PENDENTE DE SAÍDA DE MVM - 10
    FLAG_STATUS_PENDING_EXIT: "PSM",

    // PENDENTE DE ENCERRAMENTO CONTÁBIL - 8
    FLAG_STATUS_PENDING_BILLING: "PEC",

    // CONCLUÍDO - 11
    FLAG_STATUS_FINISHED: "CON",

}

export default MvmStatus;